import { render, staticRenderFns } from "./UITickerSearchWithCards.vue?vue&type=template&id=58df4753"
import script from "./UITickerSearchWithCards.vue?vue&type=script&lang=js"
export * from "./UITickerSearchWithCards.vue?vue&type=script&lang=js"
import style0 from "./UITickerSearchWithCards.vue?vue&type=style&index=0&id=58df4753&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/skade-pwa/components/ui/atom/buttons/Button.vue').default})
